var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 2C4.6865 2 2 4.6865 2 8C2 11.3135 4.6865 14 8 14C11.3135 14 14 11.3135 14 8C14 4.6865 11.3135 2 8 2ZM11.3535 6.8535L7.5735 10.6335C7.4795 10.7275 7.3525 10.78 7.22 10.78C7.0875 10.78 6.96 10.7275 6.8665 10.6335L5.14 8.907C4.9445 8.7115 4.9445 8.3955 5.14 8.2C5.3355 8.0045 5.6515 8.0045 5.847 8.2L7.22 9.573L10.6465 6.1465C10.842 5.951 11.158 5.951 11.3535 6.1465C11.549 6.342 11.549 6.658 11.3535 6.8535Z",
    fill: "#365EDE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck21);
export default __webpack_public_path__ + "static/media/check-2 (1).fdedc1eb.svg";
export { ForwardRef as ReactComponent };